import { useState, useEffect, useContext, useRef } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Text, Flex, Link } from '@chakra-ui/react';
import { CbButton } from 'ui/components';
import arcadeApiClient from 'apiClients/arcadeApiClient';
import { AuthContext } from 'providers';
import { TERMS_REQUIRED_EVENT_KEY } from 'constants/events';
export const TermsModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const acceptButtonRef = useRef<HTMLButtonElement>(null);
  const {
    logout
  } = useContext(AuthContext);
  useEffect(() => {
    const handleTermsRequired = () => {
      setIsOpen(true);
    };
    window.addEventListener(TERMS_REQUIRED_EVENT_KEY, handleTermsRequired);
    return () => {
      window.removeEventListener(TERMS_REQUIRED_EVENT_KEY, handleTermsRequired);
    };
  }, []);
  const handleAccept = () => {
    setIsSubmitting(true);
    arcadeApiClient.put('/multi_platform/users/accept_terms').then(() => {
      setIsOpen(false);
    }).catch(() => {
      // Keep modal open on error
      setIsSubmitting(false);
    });
  };
  return <Modal isOpen={isOpen} onClose={() => {}} isCentered closeOnOverlayClick={false} closeOnEsc={false} blockScrollOnMount={true} initialFocusRef={acceptButtonRef} data-sentry-element="Modal" data-sentry-component="TermsModal" data-sentry-source-file="TermsModal.tsx">
      <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(4px)" zIndex="1500" data-sentry-element="ModalOverlay" data-sentry-source-file="TermsModal.tsx" />
      <ModalContent containerProps={{
      zIndex: '1500'
    }} data-sentry-element="ModalContent" data-sentry-source-file="TermsModal.tsx">
        <ModalHeader textAlign="center" data-sentry-element="ModalHeader" data-sentry-source-file="TermsModal.tsx">Terms and Privacy Update</ModalHeader>
        <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="TermsModal.tsx">
          <Text mb={2} textAlign="center" data-sentry-element="Text" data-sentry-source-file="TermsModal.tsx">
            We have updated our Terms & Conditions and Privacy Policy.
          </Text>
          <Text mb={4} textAlign="center" data-sentry-element="Text" data-sentry-source-file="TermsModal.tsx">
            Please review and accept to proceed.
          </Text>
          <Flex flexDirection="column" alignItems="center" gap={2} mb={4} data-sentry-element="Flex" data-sentry-source-file="TermsModal.tsx">
            <Link href="https://arcade.co/terms" isExternal color="blue.500" fontSize="14px" data-sentry-element="Link" data-sentry-source-file="TermsModal.tsx">
              View Terms & Conditions
            </Link>
            <Link href="https://arcade.co/privacy" isExternal color="blue.500" fontSize="14px" data-sentry-element="Link" data-sentry-source-file="TermsModal.tsx">
              View Privacy Policy
            </Link>
          </Flex>
          <Flex flexDirection={'column'} justify="flex-end" gap={4} mb={6} data-sentry-element="Flex" data-sentry-source-file="TermsModal.tsx">
            <CbButton ref={acceptButtonRef} width="100%" onClick={handleAccept} isLoading={isSubmitting} data-sentry-element="CbButton" data-sentry-source-file="TermsModal.tsx">
              Accept
            </CbButton>
            <CbButton width="100%" variant="secondary" color="white" onClick={logout} data-sentry-element="CbButton" data-sentry-source-file="TermsModal.tsx">
              Log Out
            </CbButton>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>;
};